import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import ItemFormContainer from '../../item/components/ItemFormContainer';

const ItemHistoryList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Version',
        path: 'version',
        sort: true,
        defaultSortOrder: 'descend',
        width: '100px',
        render: (cell, row) => `${cell}${row.isCurrent ? ' (Current)' : ''}`,
      },
      {
        label: 'Text',
        path: 'text',
      },
      {
        label: 'Grammar',
        path: 'grammar.name',
        width: '200px',
      },
      {
        label: 'Type',
        path: 'type.name',
        width: '150px',
      },
      {
        label: 'Justification',
        path: 'draftCreationReason',
      },
    ]}
    rows={props.items}
    expandableComponent={(row) => (
      <div style={{ padding: '0px 10px' }}>
        <ItemFormContainer
          itemId={row.id}
          itemsTypeUrl={`/item-types`}
          endpointUrl={`items`}
          order={row.order}
          disabled={true}
          showPostPhrase
        />
      </div>
    )}
  />
);

ItemHistoryList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
};

export default ItemHistoryList;
